<template>
    <div class="slide-show" v-cloak>
        <slider :items="items" :config="config">
            <template v-slot:body="{ item, index }">
                <slide
                        :key="index"
                        :overlay="overlay"
                        :css-class="slideClass"
                        :paths="{
                        xlarge: item.xLargeFileUrl,
                        large: item.largeFileUrl,
                        medium: item.mediumFileUrl,
                        small: item.smallFileUrl
                    }"
                >
                    <div class="caption-wrapper">
                        <span class="align-middle"></span>
                        <div class="caption" v-html="item.body"></div>
                    </div>
                </slide>
            </template>
            <template v-slot:navigation v-if="items.length > 1">
                <slot name="navigation">
                    <div class="swiper-pagination"></div>
                </slot>
            </template>
        </slider>
    </div>
</template>
<script>
    import Slider from '../Slider';
    import Slide from './Slide';

    export default {
        components: { Slider, Slide },
        props: {
            items: {
                type: Array,
                default: () => [],
            },
            config: {
                type: Object,
                default: () => {
                    return {};
                },
            },
            overlay: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            slideClass() {
                if (this.items.length > 1) {
                    return '';
                }
                return 'slide-active';
            },
        },
    };
</script>
